/* global app */

'use strict';

app.directive("compareDateRange", function () {
    return {
        require: "ngModel",
        scope: {
            otherDates: "=compareDateRange"
        },
        link: function(scope, element, attributes, ngModel) {
            ngModel.$validators.compareDateInf = function (modelValue) {
                // @Todo:
                // ngModel.$setValidity('compare-date-range', new Date(modelValue) <= new Date(scope.otherDates));

                return modelValue;
            };

            scope.$watch("otherModelValue", function() {
                ngModel.$validate();
            });
        }
    };
});
